<template>
    <div class="base-form-div img-room" v-loading="loading" element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-form size="mini" :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="接收方卡号">
                <el-input :disabled="true" v-model="ruleForm.receiveCardNumber"></el-input>
            </el-form-item>
        </el-form>
        <div class="img-list">
            <!-- <div class="infoBox" v-if="!item.showImg">{{ item.content }}</div>
            <el-button class="base-button" v-if="!item.showImg" size="mini" type="primary"
                @click="againPic(item)">补发消息</el-button> -->
            <div v-for="item in msgList" :class="item.type === 1 ? 'right' : 'left'" class="msg-item">
                <span>卡号:{{ item.type === 1 ? '本机' : item.sendCardNumber }}(时间:{{ item.createTime }})</span>
                <el-image v-if="item.type === 0 && item.content.indexOf('/') === -1" class="infoImg" :src="`${API_Server}/picture/image/` + item.content"
                    :preview-src-list="[`${API_Server}/picture/image/` + item.content]">
                </el-image>
                <el-image v-else-if="item.content.indexOf('/') === -1" class="infoImg" :src="`${API_Server}/picture/imageSend/` + item.content"
                    :preview-src-list="[`${API_Server}/picture/imageSend/` + item.content]">
                </el-image>

                <div class="infoBox" v-if="item.content.indexOf('/') !== -1">{{ item.content }}</div>
                <el-button class="base-button" v-if="item.content.indexOf('/') !== -1" size="mini" type="primary"
                    @click="againPic(item)">补发消息</el-button>
            </div>
            <el-empty v-show="!loading && (!msgList || msgList.length < 1)" description="暂无数据"></el-empty>
            <!-- <div class="msg-room-right">
                <div v-for="item in sendList" class="msg-item">
                    <span>{{ item.createTime }}</span>
                    <el-image class="infoImg" :src="`${API_Server}/picture/imageSend/` + item.content"
                        :preview-src-list="[`${API_Server}/picture/imageSend/` + item.content]">
                    </el-image>
                </div>
            </div> -->
        </div>
        <div class="form-bottom">
            <el-button class="base-button" size="mini" type="primary" @click="sendImage">发送图片</el-button>
        </div>
    </div>
</template>
<script>
import uploadImg from "./uploadImg/index.vue"
import { getCommonAjax } from "@/api/common.js"
export default {
    props: ["subData"],
    data() {
        return {
            msgList: [],
            receiveList: [],
            sendList: [],
            ruleForm: {
                receiveCardNumber: undefined,
                content: "",
            },
            API_Server: window.API_Server,
            infoArr: [{}],
            urls: [
                'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg'
            ],
            loading: true

        };
    },
    methods: {
        sendImage() {
            this.$dialog.open({
                title: "发送图片",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "400px",
                    width: "680px",
                },
                content: {
                    type: "vue",
                    subCom: uploadImg,
                    subData: this.ruleForm.receiveCardNumber
                },
            });
        },
        // 查询历史消息
        getHistoryMessage(cardNumber) {
            let that = this;
            getCommonAjax('/message/pageMessagePic', {
                page: `1`,
                pageSize: `100`,
                number: cardNumber,
                beginTime: `2023-01-01 00:00:00`,
                endTime: `4023-12-31 00:00:00`
            }).then(res => {
                var items = res.result || [];
                this.msgList = items;
                that.loading = false
            }).catch(err => {
                console.error(err);
                that.loading = false
            });
        },
        // 查询历史消息
        getHistoryMessageBack(cardNumber) {
            let that = this;
            let selfArr = [];
            ///message/pageMessagePic
            //getCommonAjax('/message/pageMessage', {
            ///message/pageMessagePic?page=1&pageSize=100&number=1859807&beginTime=2023-01-01+00:00:00&endTime=2023-12-31+00:00:00    
            getCommonAjax('/message/pageMessagePic', {
                page: `1`,
                pageSize: `100`,
                number: cardNumber,
                beginTime: `2023-01-01 00:00:00`,
                endTime: `4023-12-31 00:00:00`
            }).then(res => {
                selfArr = res.result.items || [];
                selfArr.forEach(item => {
                    item.dueTime = Date.parse(item.updateTime || item.createTime);//时间
                    item.sourceType = 'self';
                    // 图片判断方式有点问题-有空修改
                    // if ((item.content.indexOf(".jpg") !== -1) || (item.content.indexOf(".png") !== -1) || (item.content.indexOf(".jpeg") !== -1)) {
                    //     item.showImg = true
                    // } else {
                    //     item.showImg = false
                    // }
                    // if ((item.content.indexOf(".jpg") !== -1) || (item.content.indexOf(".png") !== -1) || (item.content.indexOf(".jpeg") !== -1)) {
                    //     item.showImg = true
                    // } else {
                    //     item.showImg = false
                    // }
                    // 判断能否补发有问题
                    if ((item.content.indexOf("/") !== -1)) {
                        item.again = true
                    } else {
                        item.again = false
                    }
                });
                that.infoArr = selfArr;
                that.loading = false
            }).catch(err => {
                console.error(err);
                that.loading = false
            });
        },
        // 图片补发
        againPic(item) {
            getCommonAjax('/picture/reissue/' + item.idStr, {}).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: "补发请求已发送",
                        type: "success",
                    });
                }
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$message({
                        message: "发送成功",
                        type: "success",
                    });
                    this.$bus.$emit("sendMsg-MSG", this.ruleForm);
                    this.$parent.close();
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        this.loading = true;
        this.ruleForm.receiveCardNumber = this.subData.model.split("_")[1];
        this.getHistoryMessage(this.ruleForm.receiveCardNumber);
    },
    mounted() {
        this.$bus.$on("sendPic-list", () => {
            this.getHistoryMessage(this.ruleForm.receiveCardNumber);
        });
    },
    beforeDestroy() {
        this.$bus.$off("sendPic-list");
    },
};
</script>
<style scoped lang="scss">
.img-room {
    height: 520px;
    overflow-y: auto;
    padding: 0 20px !important;
}

.msg-room-left {
    width: 50%;
    height: 380px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    .el-image {
        width: 220px;
        margin-bottom: 16px;
    }
}

.msg-room-right {
    width: 50%;
    height: 380px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    .el-image {
        width: 220px;
        margin-bottom: 16px;
    }

}

.img-list {
    display: flex;
    width: 80%;
    margin: auto;
    align-items: center;
    // justify-content: space-between;
    flex-direction: row;
    border: #3AB0E3 solid 1px;
    margin-bottom: 16px;
    padding: 16px;
    box-sizing: border-box;
    flex-direction: column;
    height: 380px;
    overflow-y: auto;

    .infoBox {
        // margin-bottom: 16px;
        color: #666666;
    }

    .msg-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: dashed 1px #666666;

        .el-image {
            width: 220px;
            margin: 10px 0;
        }

        span {
            font-weight: 400;
            color: #666666;
            font-size: 12px;
        }
    }

    .msg-item:last-child {
        border-bottom: none;
    }

    .right {
        align-items: end;
    }

    .left {
        align-items: start;
    }
}
</style>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>